
import React, { useState, useEffect} from 'react';
import { useLocation,useNavigate } from 'react-router-dom';

import { utils, write } from 'xlsx';

import LoadingOverlay from 'components/LoadingOverlay.jsx';

import { useNotification } from 'config/Notification';

import { fetchAssessmentReportdetailsBySeverity as fetchAssessmentReportdetailsBySeverityService} from 'services/modules/cap/standardservice';

import '../styles/cap.css';

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { 
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TablePagination,
  TableRow
} from '@mui/material';


const ViewControlsPage = () => {
  
  // State variables
  const [assessmentsList,setAssessmentsList]=useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  
  // React router
  const navigate = useNavigate();

  // Location
  const location = useLocation();
  const urlparams = location.state;
  // Notification
  const {openNotification} = useNotification();
    
  // This method handles to change the pages
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  // This method handles to change the rows per page based on user selection
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  // Displays all the subcontrols under main control by clicking on the main control
  const handleRowClick = (rowId) => {
    setExpandedRow((prevRow) => (prevRow === rowId ? null : rowId));
  };

  // Method handles to fetch the assessment details
  const fetchPendingMitigation = async() => {
    setLoading(true);
    try {
      let params = {assessment_id:urlparams.assessmentid, status: urlparams.label};
      const response = await fetchAssessmentReportdetailsBySeverityService({ params });
      if (response.data.data.length > 0) {
        setAssessmentsList((prevList) =>prevList=[]);
        setAssessmentsList((prevList) => [...prevList, ...response.data.data]);
      }
   
    } catch (error) {
      openNotification("Error fetching pending assessments:", 'error');
      
    }finally{
      setLoading(false);
    }
  };
  
  useEffect(()=>{
    fetchPendingMitigation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // Method handles to export the assessment data in excel format
  const exportToExcel=()=> {
    let index = 0;
    const workbook = utils.book_new();
    const worksheet = utils.aoa_to_sheet([['Control Name']]);
    let allMergeCellRange = [];
    const mergeCellRange = { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } };
    allMergeCellRange.push(mergeCellRange);
    assessmentsList.forEach((item) => {
      index += 1;
      const headrow = [item.controlName];
      utils.sheet_add_aoa(worksheet, [headrow], { origin: index });
      const mergeCellRange = { s: { r: index, c: 0 }, e: { r: index, c: 6 } };
      allMergeCellRange.push(mergeCellRange);
      const subhead = ['Ref', 'Control', 'Rating', 'Rationale for Rating', 'Mitigation Suggested', 'Action taken', 'Evidence']; 
      index += 1;
      utils.sheet_add_aoa(worksheet, [subhead], { origin: index });
      item.subcontrols.forEach((ele) => {
        index += 1;
        const subrow = [ele.subcontrol, ele.subcontrolName, ele.severity, ele.rational, ele.mitigation, ele.mitigationresponse.remarks!==undefined ? ele.mitigationresponse.remarks : '', ele.mitigationresponse.evidence!==undefined ? ele.mitigationresponse.evidence : '']; 
        utils.sheet_add_aoa(worksheet, [subrow], { origin: index });
      });
    });
    worksheet['!merges'] = allMergeCellRange;
    utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = write(workbook, { type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Mitigation' + urlparams.assessmentid + '.xlsx'; 
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="row py-1">
        <p>
          <img   className="px-1 icons-style" src="../assets/icons/003-clipboard.svg" alt="View"  />
          <b  className="px-1">View Controls </b>
          <img  className="px-1 icons-style" src="../assets/icons/right-layer.svg" alt="View"   />

          {urlparams.standard==='CIS' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-cis.png"  alt="View" draggable="false" />
          )}
          {urlparams.standard==='ISO-27001' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-iso-27001.png" alt="View"  draggable="false" />
          )}
          {urlparams.standard==='NIST' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-nist.png" alt="View"  draggable="false" />
          )}
          {urlparams.standard==='COBIT' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-cobit.png"  alt="View" draggable="false" />
          )}
          {urlparams.standard==='TISAX' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-tisax.png" alt="View"  draggable="false" />
          )}
          {urlparams.standard==='NIS 2.0' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-nis2.png" alt="View"  draggable="false" />
          )}
          {urlparams.standard==='Ransomware' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-ransomware.png"  alt="View" draggable="false" />
          )}
          {urlparams.standard==='Data Protection' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-data-protection.png" alt="View"  draggable="false" />
          )}
          {urlparams.standard==='Supplier Risk' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-supplier-risk.png" alt="View"  draggable="false" />
          )}
          <span> { urlparams.standard }  </span> - <span>{ urlparams.assessmentid }</span> 
        </p>
      </div>

      {loading && <LoadingOverlay />}
      <div>
        {assessmentsList.length>0 &&(
          <div>
            <div  className='export-excel'>
              <button className='approve-button' onClick={()=>exportToExcel()}>Export to excel</button>      
            </div>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={3}>Control name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                    ? assessmentsList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : assessmentsList
                  ).map((item) => (
                    <React.Fragment key={item.controlID}>
                      <TableRow >
                        <TableCell>
                          <IconButton
                            className='expand-row'
                            size="small"
                            onClick={() => handleRowClick(item.controlID)}
                          >
                            {expandedRow === item.controlID ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </IconButton>
                        </TableCell>
                        <TableCell>{item.controlID +' : ' + item.controlName}</TableCell>
                        <TableCell>{item.assessment_id}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={3}>
                          <Collapse in={expandedRow === item.controlID} timeout="auto" unmountOnExit>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Ref</TableCell>
                                  <TableCell>Control</TableCell>
                                  <TableCell>Rating</TableCell>
                                  <TableCell>Rationale for rating</TableCell>
                                  <TableCell>Mitigation suggested</TableCell>
                                  <TableCell>Action taken</TableCell>
                                  <TableCell>Evidence</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {item.subcontrols.map((subcontrol) => (
                                  <TableRow key={subcontrol.subcontrolID}>
                                    <TableCell>{subcontrol.subcontrol}</TableCell>
                                    <TableCell>
                                      <div className='subcontrols'>
                                        {subcontrol.subcontrolName}
                                      </div>
                                    </TableCell>
                                    <TableCell className='subcontrols'>{subcontrol.severity}</TableCell>
                                    <TableCell className='subcontrols'>{subcontrol.rational}</TableCell>
                                    <TableCell className='subcontrols'>{subcontrol.mitigation || ''}</TableCell>
                                    <TableCell className='subcontrols'>{subcontrol.mitigationresponse?.remarks}</TableCell>
                                    <TableCell>
                                      {(
                                        (subcontrol.mitigationresponse?.evidence!==undefined) &&(
                                          <a className='text-primary' href={subcontrol.mitigationresponse?.evidence} target="_blank" rel="noreferrer"> Download </a>
                                        )
                                      )}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                component="div"
                count={assessmentsList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </div>
        )}
        {assessmentsList.length>0 &&(
          <div className='assessments-list'>
            <button
              className="go-back-button"
              style={{ width: '150px' }}
              onClick={()=>  navigate('/cap/dashboard')}
            >
              <ArrowLeftIcon  />
              Go back
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default ViewControlsPage;
